import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdDirective } from './ad.directive';
import { EventService } from './event.service';
import { OverlayContainerComponent } from './overlay-container.component';
import { Overlay } from './overlay.service';

@NgModule({
  declarations: [OverlayContainerComponent, AdDirective],
  imports: [CommonModule],
  exports: [],
  providers: [Overlay, EventService],
  bootstrap: [],
})
export class OverlayModule {}
